import React, { useState } from 'react';

const SnapshotEditor = ({ snapshot, label, clickButtonToEdit }) => {
  const [disabled, setDisabled] = useState(clickButtonToEdit === false ? false : true);
  const [value, setValue] = useState(snapshot.val() || '');

  const saveToFirebase = async () => {
    await snapshot.ref.set(value);
    setDisabled(true);
  };

  return (
    <div className="input-group">
      <label>{label || snapshot.key}</label>

      {disabled ? (
        <span>{snapshot.val() || ''}</span>
      ) : (
        <input
          className="fb-patheditor"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      )}

      {clickButtonToEdit !== false && (
        disabled ? (
          <button onClick={() => setDisabled(false)}>Edit</button>
        ) : (
          <button onClick={saveToFirebase}>Done</button>
        )
      )}
    </div>
  );
};

export default SnapshotEditor;